import React from 'react';
import type { HeadProps, PageProps } from 'gatsby';
import { graphql } from 'gatsby';
import { parse as parseDate } from 'date-fns/parse';
import type { Post } from '../components/PostsList';
import PostsList from '../components/PostsList';
import Pagination from '../components/Pagination';
import HtmlElements from '../components/HtmlElements';
import SEO from '../components/SEO';

type PostsPageContext = {
    title: string;
    currentPage: number;
    postsLimit: number;
    postsOffset: number;
    prevPagePath: string;
    nextPagePath: string;
    hasPrevPage: boolean;
    hasNextPage: boolean;
};

export const PostsPage = ({
    data,
    pageContext,
}: PageProps<Queries.PostsPageQuery, PostsPageContext>) => {
    const { title, prevPagePath, nextPagePath, hasPrevPage, hasNextPage } =
        pageContext;
    const posts = data?.postFiles?.nodes.map<Post>((post) => ({
        id: post?.childMdx?.id || new Date().getMilliseconds().toString(),
        slug: post?.childMdx?.frontmatter?.slug || '',
        title: post?.childMdx?.frontmatter?.title || '',
        category: post?.childMdx?.frontmatter?.category || '',
        // @ts-ignore
        tags: post?.childMdx?.frontmatter?.tags || [],
        excerpt:
            post?.childMdx?.frontmatter?.excerpt ||
            post?.childMdx?.excerpt ||
            '',
        thumb: post?.childMdx?.frontmatter?.thumb || '',
        date: parseDate(
            post?.childMdx?.frontmatter?.date || '',
            'yyyy-MM-dd',
            new Date(),
        ),
    }));
    return (
        <>
            <HtmlElements.h1>{title}</HtmlElements.h1>
            <PostsList posts={posts} />
            <Pagination
                prevPagePath={prevPagePath}
                nextPagePath={nextPagePath}
                hasPrevPage={hasPrevPage}
                hasNextPage={hasNextPage}
            />
        </>
    );
};

export const Head = ({ location }: HeadProps<Queries.PostsPageQuery>) => (
    <SEO title="Posts" description={undefined} pathname={location.pathname} />
);

export const query = graphql`
    query PostsPage($postsLimit: Int!, $postsOffset: Int!) {
        postFiles: allFile(
            filter: { sourceInstanceName: { eq: "posts" } }
            sort: { name: DESC }
            limit: $postsLimit
            skip: $postsOffset
        ) {
            nodes {
                childMdx {
                    id
                    excerpt
                    frontmatter {
                        title
                        slug
                        excerpt
                        tags
                        category
                        date
                        thumb
                    }
                }
            }
        }
    }
`;

export default PostsPage;
